import React from "react";

const Ticari_elektronik_ileti_onayi = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>TİCARİ ELEKTRONİK İLETİ (ETK) ONAY VE AÇIK RIZA METNİ</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            İşbu metin ile, kişisel verilerimin Von Dijital Yazılım Hizmetleri LTD. ŞTİ. ("Şirket")
            tarafından, doğrudan veya dolaylı olarak yürütülen pazarlama ve tanıtım faaliyetleri
            kapsamında işlenmesine ilişkin açık rızamı veriyorum. Bu kapsamda, tarafıma sunulan
            ürün ve hizmetler, kampanyalar, promosyonlar, avantajlar, reklamlar, pazar araştırmaları,
            anketler ve müşteri memnuniyeti çalışmalarına ilişkin bilgilendirmelerin iletilmesi
            amacıyla iletişim bilgilerim kullanılabilecektir.
          </p>
          <p style={styles.text}>
            Kişisel verilerim, Şirket tarafından tarafıma SMS, kısa mesaj, mobil uygulama içi bildirim,
            e-posta, otomatik arama sistemleri, telefon aramaları, bluetooth, beacon ve diğer
            kablosuz ağlar, sosyal medya platformları ve diğer elektronik iletişim araçları aracılığıyla
            ticari elektronik ileti gönderilmesi amacıyla işlenecektir.
          </p>
          <p style={styles.text}>
            Ayrıca, bu faaliyetlerin sağlıklı ve etkin bir şekilde yürütülebilmesi amacıyla kişisel
            verilerimin, Şirketin hizmet aldığı teknoloji ve pazarlama altyapısı sağlayıcıları, veri işleme
            ve iletişim hizmeti sunan üçüncü taraf tedarikçiler ile paylaşılmasına ve bu paylaşımın
            işbu amaçla sınırlı olmasına açıkça onay veriyorum.
          </p>
          <p style={styles.text}>
            Veri işleme ve paylaşım süreçleri, 6698 sayılı Kişisel Verilerin Korunması Kanunu ve ilgili
            mevzuat hükümleri kapsamında gerçekleştirilecek olup, kişisel verilerimin güvenliği,
            gizliliği ve bütünlüğü Şirket tarafından sağlanacaktır. İşbu açık rıza, tarafıma yönelik ticari
            elektronik ileti gönderiminin yasal dayanağını oluşturmakta olup, rızamı dilediğim zaman
            geri çekme hakkım saklıdır. Rızamın geri çekilmesi halinde, tarafıma ticari elektronik ileti
            gönderimi durdurulacaktır.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Ticari_elektronik_ileti_onayi;